import FlexPane from './_flex-pane.js'
import PriceBoostItem from './_price-boost-item.js'

export default {
  name: 'PriceBoostMarketContent',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '1px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    priceBoostItem: {
      configSet: PriceBoostItem,
      configValues: {
        selectionButton: {
          view: {
            width: '196px',
            _mobile_width: '100%',
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
